exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subtest-type{margin-top:20px;padding:20px;border:1px solid #dee2e6;border-radius:10px}.subtest-file{margin-top:5px;margin-bottom:5px}.next-to-button-icon{vertical-align:middle;width:28px}", ""]);

// exports
